import React from 'react';
import ReactDOM from 'react-dom';
import App from './views/root/App';
import "./assets/css/global.scss";
import { BrowserRouter } from 'react-router-dom';
import { setToLs } from './utils/storage';
import { themeConfigs as THEMES } from './constants';
import { Provider } from 'react-redux';
import store from './store/index';
import './i18nextConf';
import './configs/axiosInterceptor'; // Initialize axios interceptors
const Index = () => {
  setToLs('all-themes', THEMES);
  return (
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  )
}


ReactDOM.render(
  <Index />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

